import * as _ from 'lodash';
import React, { Fragment } from 'react';
import PerfectScrollBar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { makeGetStockTrade } from '../../../../lib/selector';
import { formatVolume10, numberFormat } from '../../../../utils';
import Loading from '../../../loading';
// import PieVolPrice from '../../../hightchart/pieVolPrice';

class BuocGia extends React.PureComponent {
  render() {
    const { stockTrade, stockTradeRequesting } = this.props;

    let _stockTrade = [...stockTrade];
    const _sumVol = _.sumBy(_stockTrade, 'lastVol') * 10;
    // const xxx = _.chain(_stockTrade)
    //   .groupBy('lastPrice')
    //   .toPairs()
    //   .map((objs, key) => ({
    //     lastPrice: objs[0],
    //     // obj: objs,
    //     sumVol: _.sumBy(objs[1], 'lastVol'),
    //   }))
    //   .value();
    // // console.log(xxx);

    // const _sorted = _.sortBy(xxx, ['sumVol']).reverse();
    // // console.log(_sorted);
    // const top5 = _sorted && _sorted.length > 5 ? _sorted.slice(0, 5) : _sorted;

    // console.log(top5);

    return (
      <Fragment>
        <PerfectScrollBar style={{ height: 'calc( 100vh - 415px )' }}>
          <table className="table table-borderless table-fix">
            <thead>
              <tr>
                <th>Thời gian</th>
                <th className="text-right bg-white">KL</th>
                <th className="text-right bg-white">Giá</th>
                <th className="text-right bg-white">+/-</th>
              </tr>
            </thead>
            <tbody>
              {stockTrade &&
                !!stockTrade.length &&
                stockTrade.map((item, index) => {
                  if (!item) return null;
                  return (
                    <tr key={index}>
                      <td className="text-center content-read fz-14">
                        {item.time}
                      </td>
                      <td className="text-right content-read fz-14">
                        {formatVolume10(item.lastVol)}
                      </td>
                      <td className={'text-right fz-14 ' + item.cl}>
                        {item.lastPrice}
                      </td>
                      <td className={'text-right fz-14 ' + item.cl}>
                        {item.change}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {stockTradeRequesting && <Loading />}
        </PerfectScrollBar>
        <p className="mb-0 mt-2 d-flex justify-content-between">
          <span className="fz-14 font-weight-bold">Tổng KL</span>
          <span className="fz-14">{numberFormat(_sumVol, 0)}</span>
        </p>
        {/* <p className="fz-14 text-center font-weight-bold mb-0">Phân bổ khớp lệnh</p>
        {top5 && top5.length > 3 && <PieVolPrice data={top5} />} */}
      </Fragment>
    );
  }
}

const makeMapStateToProps = () => {
  const getStockTrade = makeGetStockTrade();

  const mapStateToProps = (state) => {
    return {
      stockTrade: getStockTrade(state),
      stockTradeRequesting: state.stockDetail.stockTradeRequesting,
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(BuocGia);
